import React from 'react';
import LandingPage from './LandingPage';
import TechnologyPage from './pages/TechnologyPage';
import IndustriesPage from './pages/IndustriesPage';
import TeamPage from './pages/TeamPage';
import DigitalMaterialPassportPage from './pages/DigitalMaterialPassportPage';

const PAGES = {
  '/technology': TechnologyPage,
  '/industries': IndustriesPage,
  '/team': TeamPage,
  '/digital-material-passport': DigitalMaterialPassportPage,
};

function App() {
  const Page = PAGES[window.location.pathname] || LandingPage;

  return (
    <div className="App">
      <Page />
    </div>
  );
}

export default App;
